import Modal from 'react-bootstrap/Modal';
import { IoClose } from 'react-icons/io5';
import modal from '../../css/style.module.css';

const PayoutConfirmModal = ({
  show,
  title,
  message,
  confirmLabel = 'Confirm',
  loading = false,
  onClose,
  onConfirm,
}) => (
  <Modal show={show} onHide={onClose} centered>
    <Modal.Body style={{ padding: '30px' }}>
      <div className={modal.modelsuccessfullyclose}>
        <IoClose color="#000000" size={25} onClick={onClose} />
      </div>
      <div className={modal.modelsuccessfullydelete}>
        <h6 style={{ marginBottom: 12 }}>{title}</h6>
        <p>{message}</p>
        <div className={modal.modelsuccessfullybuttons}>
          <button type="button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            style={{ background: '#5A5A5A' }}
          >
            {loading ? 'Please wait...' : confirmLabel}
          </button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
);

export default PayoutConfirmModal;
